// extracted by mini-css-extract-plugin
export default {"container":"SesssionExpiredModal_container__izJRF"};